export default __webpack_public_path__ + "static/solution_back-0cb4e69ce8cdc711f956862c4e9f9a6f.png";